import request from '@/utils/request'

// 查询进行中的营销活动
export function getProcessingActivityList() {
  return request({
    url: '/api/manage/member/marketing/campaign/processing/list',
    method: 'get',
  })
}


//是否老客户
export function checkOldEnt() {
    return request({
        url: '/api/manage/labor/check/old/ent/customer',
        method: 'get',
    })
}

export default {
  getProcessingActivityList,
    checkOldEnt
}
